import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import WorkHeroSection from './sections/WorkHeroSection';
import Offer1Section from './sections/Offer1Section';
import Offer2Section from './sections/Offer2Section';
import Offer3Section from './sections/Offer3Section';
import Offer4Section from './sections/Offer4Section';
import WorkTestimonialsSection from './sections/WorkTestimonialsSection';
import SessionTypesSection from './sections/SessionTypesSection';
import BookCalendlySection from './sections/BookCalendlySection';
import BookClosingSection from './sections/BookClosingSection';

const SectionDivider = () => (
  <div className="w-full h-px bg-accent-500/30" />
);

export default function WorkWithMe() {
  useEffect(() => {
    document.title = 'Work With Me & Book a Session | MANDIE OZEE.';
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <WorkHeroSection />
        <SectionDivider />
        <Offer1Section />
        <SectionDivider />
        <Offer2Section />
        <SectionDivider />
        <Offer3Section />
        <SectionDivider />
        <Offer4Section />
        <SectionDivider />
        <WorkTestimonialsSection />
        <SectionDivider />
        <SessionTypesSection />
        <SectionDivider />
        <BookCalendlySection />
        <SectionDivider />
        <BookClosingSection />
      </main>
      <Footer />
    </div>
  );
}